import React from "react";

import tanmaiImg from "./images/tanmai.png";
import alisonImg from "./images/alison.png";
import dianaImg from "./images/diana.png";
import jamesImg from "./images/james.png";
import lathaImg from "./images/latha.png";
import deepImg from "./images/deep.png";
import evanImg from "./images/evan.png";
import adamImg from "./images/adam.png";
import bhaskarImg from "./images/bhaskar.png";
import ashwinGoyalImg from "./images/ashwin-goyal.png";
import nagarajaImg from "./images/nagaraja.png";
import gurumurthyImg from "./images/gurumurthy-sithuraj.png";
const speakersDetails = [
  {
    url: "/enterprisegraphql/2020/speakers/latha-budideti/",
    metaTags: {
      title: "Latha Budideti | Digital Transformation at Optum",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/latha-budideti/",
      description:
        "Latha started her career as an engineer 19 years ago, now leading a team of excellent engineers at Optum. The team’s charter is focused on reducing “IT Waste” with platform architecture concepts enabling engineering teams to build and ship software fast. | The Enterprise Clinical Team at Optum has implemented an elegant GraphQL infrastructure and are using GraphQL & Hasura in their modernization journey. In this panel with senior leadership at Optum, they will share the how and the why of their approach, the business benefits they’re observing from this shift, and finally we will hear their insights on best practices for architects in large enterprises who are looking to adapt GraphQL within their own organization.",
    },
    talkDetails: [
      {
        title: "Digital Transformation at Optum",
        description: {
          lists: [
            "The Enterprise Clinical Team at Optum has implemented an elegant GraphQL infrastructure and are using GraphQL & Hasura in their modernization journey. In this panel with senior leadership at Optum, they will share the how and the why of their approach, the business benefits they’re observing from this shift, and finally we will hear their insights on best practices for architects in large enterprises who are looking to adapt GraphQL within their own organization.",
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/digital-transformation-at-optum/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/digital-transformation-at-optum/watch/",
    talkTitleType: "Talk Title",
    time: "11:45am - 12:30pm",
    speakersName: "Latha Budideti",
    speakersImg: lathaImg,
    linkedinLink: "https://www.linkedin.com/in/latha-budideti-260a0b141/",
    about: {
      lists: [
        "Latha started her career as an engineer 19 years ago, now leading a team of excellent engineers at Optum. The team’s charter is focused on reducing “IT Waste” with platform architecture concepts enabling engineering teams to build and ship software fast.",
      ],
    },
    speakersDesignation: (
      <span>
        VP Software Engineering
        <br />
        Optum
      </span>
    ),
  },
  {
    url: "/enterprisegraphql/2020/speakers/deep-ganguly/",
    metaTags: {
      title: "Deep Ganguly | Data Federation with GraphQL",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/deep-ganguly/",
      description:
        "Deep is a Product leader and Customer advocate with experience in building rich Business Technology Platform. Currently working at SAP, he is driving the Integration and API Journey for Enterprise Customers. | Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
    },
    talkDetails: [
      {
        title: "Data Federation with GraphQL",
        description: {
          lists: [
            "Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
          ],
          subLists: [
            "How do people access data?",
            "How does GraphQL help?",
            "What kind of systems are being used to get GraphQL to federate data within an org?",
            "What do you wish you’d known before you started your Data Federation journey?",
            "Let’s learn from the panel.",
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/data-federation-with-graphql/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/data-federation-with-graphql/watch/",
    talkTitleType: "Panel Discussion",
    time: "10:30am - 11:30am",
    speakersName: "Deep Ganguly",
    speakersImg: deepImg,
    twitterLink: "https://twitter.com/deepgly",
    linkedinLink: "https://www.linkedin.com/in/ideepg/",
    about: {
      lists: [
        "Deep is a Product leader and Customer advocate with experience in building rich Business Technology Platform. Currently working at SAP, he is driving the Integration and API Journey for Enterprise Customers.",
      ],
    },
    speakersDesignation: (
      <span>
        Product Manager
        <br /> SAP Cloud Platform Integration Suite
      </span>
    ),
  },
  {
    url: "/enterprisegraphql/2020/speakers/james-governor/",
    metaTags: {
      title: "James Governor | The New Data Fabric, 2020 as a trigger for innovation",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/james-governor/",
      description:
        "James Governor is co-founder of RedMonk, the only developer-focused industry analyst firm. Based in London, he advises clients on developer-led technology adoption, cloud, open source, community and technology strategy. | The industry is quickly moving to a model of higher level of services and abstraction, in all layers of the stack, from compute to storage to networking and application deployment and delivery. While we've seen a ton of innovation in data and data management, we're now seeing an acceleration in that space, with developer experience as a key driver for the new platforms and capabilities. Programming languages are becoming more data friendly, and data services are increasingly being defined by new APIs, notably GraphQL. The pendulum is swinging from 3 tier application models to 2 tier, with rich interactive front ends orchestrating from a palette of back end services - client/serverless is a thing. In this talk James will discuss how enterprises can build more powerful data driven apps using new technologies and methods, putting all of this change into context.",
    },
    talkDetails: [
      {
        title: "The New Data Fabric, 2020 as a trigger for innovation",
        description: {
          lists: [
            "The industry is quickly moving to a model of higher level of services and abstraction, in all layers of the stack, from compute to storage to networking and application deployment and delivery. While we've seen a ton of innovation in data and data management, we're now seeing an acceleration in that space, with developer experience as a key driver for the new platforms and capabilities. Programming languages are becoming more data friendly, and data services are increasingly being defined by new APIs, notably GraphQL. The pendulum is swinging from 3 tier application models to 2 tier, with rich interactive front ends orchestrating from a palette of back end services - client/serverless is a thing. In this talk James will discuss how enterprises can build more powerful data driven apps using new technologies and methods, putting all of this change into context.",
          ],
        },
      },
    ],
    videoPageLink:
      "/enterprisegraphql/2020/talks/the-new-data-fabric-2020-as-a-trigger-for-innovation/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/the-new-data-fabric-2020-as-a-trigger-for-innovation/watch/",
    talkTitleType: "Talk Title",
    time: "9:45am - 10:30am",
    speakersName: "James Governor",
    speakersImg: jamesImg,
    twitterLink: "https://twitter.com/monkchips",
    linkedinLink: "https://www.linkedin.com/in/jamesgovernor/",
    about: {
      lists: [
        "James Governor is co-founder of RedMonk, the only developer-focused industry analyst firm. Based in London, he advises clients on developer-led technology adoption, cloud, open source, community and technology strategy.",
      ],
    },
    speakersDesignation: (
      <span>
        Founder
        <br /> RedMonk
      </span>
    ),
    description: {
      lists: [
        "The industry is quickly moving to a model of higher level of services and abstraction, in all layers of the stack, from compute to storage to networking and application deployment and delivery. While we've seen a ton of innovation in data and data management, we're now seeing an acceleration in that space, with developer experience as a key driver for the new platforms and capabilities. Programming languages are becoming more data friendly, and data services are increasingly being defined by new APIs, notably GraphQL. The pendulum is swinging from 3 tier application models to 2 tier, with rich interactive front ends orchestrating from a palette of back end services - client/serverless is a thing. In this talk James will discuss how enterprises can build more powerful data driven apps using new technologies and methods, putting all of this change into context.",
      ],
    },
  },
  {
    url: "/enterprisegraphql/2020/speakers/ashwin-goyal/",
    metaTags: {
      title: "Ashwin Goyal | Moving Fast & Not Breaking Things",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/ashwin-goyal/",
      description:
        "Ashwin uses technology to help startups manage and sustain their growth. He was formerly CTO at Bombay Shirts and Pocket Aces. At Swiggy/New Initiatives, he’s helping build the next set of products to bring unparalleled convenience to consumers. | This panel will focus on introducing new tech (GraphQL) incrementally without breaking existing systems. The topics on the panel will focus on the adoption motions of GraphQL, developer productivity, benefits that you see as an org, what problems GraphQL solutions are solving, best practices for org-wide incremental adoption, etc. From success stories to challenges (that can be shared publicly), expect a frank conversation of the good, the bad, and the amazing.",
    },
    talkDetails: [
      {
        title: "Moving Fast & Not Breaking Things",
        description: {
          lists: [
            "This panel will focus on introducing new tech (GraphQL) incrementally without breaking existing systems. The topics on the panel will focus on the adoption motions of GraphQL, developer productivity, benefits that you see as an org, what problems GraphQL solutions are solving, best practices for org-wide incremental adoption, etc. From success stories to challenges (that can be shared publicly), expect a frank conversation of the good, the bad, and the amazing.",
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/moving-fast-and-not-breaking-things/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/moving-fast-and-not-breaking-things/watch/",
    talkTitleType: "Panel Discussion",
    time: "1:15pm - 2:00pm",
    speakersName: <span>Ashwin Goyal</span>,
    speakersImg: ashwinGoyalImg,
    linkedinLink: "https://www.linkedin.com/in/ashwingo/",
    about: {
      lists: [
        "Ashwin uses technology to help startups manage and sustain their growth. He was formerly CTO at Bombay Shirts and Pocket Aces. At Swiggy/New Initiatives, he’s helping build the next set of products to bring unparalleled convenience to consumers.",
      ],
    },
    speakersDesignation: (
      <span>
        New Initiatives <br />
        Swiggy
      </span>
    ),
    description: {
      lists: [
        "This panel will focus on introducing new tech (GraphQL) incrementally without breaking existing systems. The topics on the panel will focus on the adoption motions of GraphQL, developer productivity, benefits that you see as an org, what problems GraphQL solutions are solving, best practices for org-wide incremental adoption, etc. From success stories to challenges (that can be shared publicly), expect a frank conversation of the good, the bad, and the amazing.",
      ],
    },
  },
  {
    url: "/enterprisegraphql/2020/speakers/evan-huus/",
    metaTags: {
      title: "Evan Huus | Moving Fast & Not Breaking Things",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/evan-huus/",
      description:
        "Evan Huus is a Developer Lead at Shopify, managing the team responsible for their GraphQL infrastructure, tooling, and best practices. When not growing programs or people, you can probably find him making music or reading philosophy. He lives in Ottawa, Canada. | This panel will focus on introducing new tech (GraphQL) incrementally without breaking existing systems. The topics on the panel will focus on the adoption motions of GraphQL, developer productivity, benefits that you see as an org, what problems GraphQL solutions are solving, best practices for org-wide incremental adoption, etc. From success stories to challenges (that can be shared publicly), expect a frank conversation of the good, the bad, and the amazing.",
    },
    talkDetails: [
      {
        title: "Moving Fast & Not Breaking Things",
        description: {
          lists: [
            "This panel will focus on introducing new tech (GraphQL) incrementally without breaking existing systems. The topics on the panel will focus on the adoption motions of GraphQL, developer productivity, benefits that you see as an org, what problems GraphQL solutions are solving, best practices for org-wide incremental adoption, etc. From success stories to challenges (that can be shared publicly), expect a frank conversation of the good, the bad, and the amazing.",
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/moving-fast-and-not-breaking-things/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/moving-fast-and-not-breaking-things/watch/",
    talkTitleType: "Panel Discussion",
    time: "1:15pm - 2:00pm",
    speakersName: "Evan Huus",
    speakersImg: evanImg,
    linkedinLink: "https://www.linkedin.com/in/eapache/",
    about: {
      lists: [
        "Evan Huus is a Developer Lead at Shopify, managing the team responsible for their GraphQL infrastructure, tooling, and best practices. When not growing programs or people, you can probably find him making music or reading philosophy. He lives in Ottawa, Canada.",
      ],
    },
    speakersDesignation: (
      <span>
        Developer Lead
        <br /> Shopify
      </span>
    ),
    description: {
      lists: [
        "This panel will focus on introducing new tech (GraphQL) incrementally without breaking existing systems. The topics on the panel will focus on the adoption motions of GraphQL, developer productivity, benefits that you see as an org, what problems GraphQL solutions are solving, best practices for org-wide incremental adoption, etc. From success stories to challenges (that can be shared publicly), expect a frank conversation of the good, the bad, and the amazing.",
      ],
    },
  },
  {
    url: "/enterprisegraphql/2020/speakers/tanmai-gopal/",
    metaTags: {
      title: "Tanmai Gopal | Moving Fast & Not Breaking Things",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/tanmai-gopal/",
      description:
        "Tanmai, Hasura CEO and founder, will keynote the Enterprise GraphQL conference addressing these questions, and more, while laying out the foundation for understanding how to unlock your data with GraphQL in your organisation (regardless of the size). | Technology adoption in the enterprise can be a winding road. When new frameworks, new approaches, new design patterns, even new query languages are developed there is time between emergence and maturation.",
    },
    talkDetails: [
      {
        title: "Enabling Innovation & Empowering Developers - GraphQL’s role in the Enterprise",
        borderBottom: "enterpriseBorBottomGray",
        description: {
          lists: [
            "Technology adoption in the enterprise can be a winding road. When new frameworks, new approaches, new design patterns, even new query languages are developed there is time between emergence and maturation. Have you asked, or have you heard, the questions:",
          ],
          subLists: [
            "Is GraphQL only for side projects?",
            "Is anyone really using GraphQL at enterprise scale?",
            "Is GraphQL production ready?",
          ],
          listsTwo: [
            "Tanmai, Hasura CEO and founder, will keynote the Enterprise GraphQL conference addressing these questions, and more, while laying out the foundation for understanding how to unlock your data with GraphQL in your organisation (regardless of the size).",
          ],
        },
      },
    ],
    videoPageLink:
      "/enterprisegraphql/2020/talks/enabling-innovation-and-empowering-developers-graphqls-role-in-the-enterprise/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/enabling-innovation-and-empowering-developers-graphqls-role-in-the-enterprise/watch/",
    talkTitleType: "Talk Title",
    time: "1:15pm - 2:00pm",
    speakersName: "Tanmai Gopal",
    speakersImg: tanmaiImg,
    twitterLink: "https://twitter.com/tanmaigo",
    linkedinLink: "https://www.linkedin.com/in/tanmaig/",
    githubLink: "https://github.com/coco98",
    about: {
      lists: [
        "Tanmai is the co-founder of Hasura. He is a StackOverflow powered fullstack, polyglot developer whose areas of interest and work span react, GraphQL, nodejs, python, haskell, docker, postgres, kubernetes. He is passionate about making it easy to build things and is the instructor of India's largest MOOC imad.tech with over 250,000 students.",
      ],
    },
    speakersDesignation: (
      <span>
        Co-Founder
        <br /> Hasura
      </span>
    ),
  },
  {
    url: "/enterprisegraphql/2020/speakers/diana-suvorova/",
    metaTags: {
      title: "Diana Suvorova | Data Federation with GraphQL",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/diana-suvorova/",
      description:
        "I am a Front End engineer at Uber. I am a believer in designing interfaces for emotions and creating an architecture for cross team collaboration. Most recently working on systematically introducing GraphQL into established micro-services architecture. | Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
    },
    talkDetails: [
      {
        title: "Data Federation with GraphQL",
        description: {
          lists: [
            "Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
          ],
          subLists: [
            "How do people access data?",
            "How does GraphQL help?",
            "What kind of systems are being used to get GraphQL to federate data within an org?",
            "What do you wish you’d known before you started your Data Federation journey?",
            "Let’s learn from the panel.",
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/data-federation-with-graphql/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/data-federation-with-graphql/watch/",
    talkTitleType: "Panel Discussion",
    time: "10:30am - 11:30am",
    speakersName: "Diana Suvorova",
    speakersImg: dianaImg,
    twitterLink: "https://twitter.com/DianaSuvorova",
    linkedinLink: "https://www.linkedin.com/in/dianasuvorova/",
    about: {
      lists: [
        "I am a Front End engineer at Uber. I am a believer in designing interfaces for emotions and creating an architecture for cross team collaboration. Most recently working on systematically introducing GraphQL into established micro-services architecture.",
      ],
    },
    speakersDesignation: (
      <span>
        Senior Software Engineer <br />
        Uber
      </span>
    ),
  },
  {
    url: "/enterprisegraphql/2020/speakers/allison-kunz/",
    metaTags: {
      title: "Allison Kunz | Data Federation with GraphQL",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/allison-kunz/",
      description:
        "Allison is a Solutions Engineer at Hasura | Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
    },
    talkDetails: [
      {
        title: "Data Federation with GraphQL",
        description: {
          lists: [
            "Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
          ],
          subLists: [
            "How do people access data?",
            "How does GraphQL help?",
            "What kind of systems are being used to get GraphQL to federate data within an org?",
            "What do you wish you’d known before you started your Data Federation journey?",
            "Let’s learn from the panel.",
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/data-federation-with-graphql/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/data-federation-with-graphql/watch/",
    talkTitleType: "Panel Discussion",
    time: "10:30am - 11:30am",
    speakersName: "Allison Kunz",
    speakersImg: alisonImg,
    linkedinLink: "https://www.linkedin.com/in/tafka-labs/",
    about: {
      lists: ["Allison is a Solutions Engineer at Hasura"],
    },
    speakersDesignation: (
      <span>
        Solutions Engineer <br />
        Hasura
      </span>
    ),
  },
  {
    url: "/enterprisegraphql/2020/speakers/adam-miskiewicz/",
    metaTags: {
      title: "Adam Miskiewicz | Building Airbnb’s Data Graph",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/adam-miskiewicz/",
      description:
        'Adam Miskiewicz is a staff engineer at Airbnb working primarily on GraphQL infrastructure. Adam has over 13 years of experience building web and mobile applications, and has been using GraphQL in production since the day it was open-sourced. | As Airbnb transitioned from its Ruby on Rails monolith to a service-oriented architecture, many parts of our application have become better managed, better organized, and higher quality. Our APIs and our data, however, became fragmented and difficult to use and understand. Over the past year, Airbnb has been building a platform to unify our data graph and make data access and product logic more understandable and reusable, allowing us to harmonize our many microservices through what we call a "data-oriented service mesh". I’ll talk about our motivations, the developer experience of using this unified graph, and where we’re looking to take the platform in the future.',
    },
    talkDetails: [
      {
        title: "Building Airbnb’s Data Graph",
        description: {
          lists: [
            'As Airbnb transitioned from its Ruby on Rails monolith to a service-oriented architecture, many parts of our application have become better managed, better organized, and higher quality. Our APIs and our data, however, became fragmented and difficult to use and understand. Over the past year, Airbnb has been building a platform to unify our data graph and make data access and product logic more understandable and reusable, allowing us to harmonize our many microservices through what we call a "data-oriented service mesh". I’ll talk about our motivations, the developer experience of using this unified graph, and where we’re looking to take the platform in the future.',
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/building-airbnbs-Data-graph/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/building-airbnbs-Data-graph/watch/",
    talkTitleType: "Talk Title",
    time: "12:30pm - 1:15pm",
    speakersName: "Adam Miskiewicz",
    speakersImg: adamImg,
    twitterLink: "https://twitter.com/skevy?lang=en",
    linkedinLink: "https://www.linkedin.com/in/adammiskiewicz/",
    about: {
      lists: [
        "Adam Miskiewicz is a staff engineer at Airbnb working primarily on GraphQL infrastructure. Adam has over 13 years of experience building web and mobile applications, and has been using GraphQL in production since the day it was open-sourced.",
      ],
    },
    speakersDesignation: (
      <span>
        Staff Engineer <br />
        Airbnb
      </span>
    ),
  },
  {
    url: "/enterprisegraphql/2020/speakers/bhaskar-ghosh/",
    metaTags: {
      title: "Bhaskar Ghosh | Data Federation with GraphQL",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/bhaskar-ghosh/",
      description:
        "Bhaskar Ghosh (BG)  is  Partner and CTO at Silicon Valley venture capital firm 8VC, where he focuses on investing in early-phase start-ups building B2B SaaS, enterprise infrastructure and  data-driven businesses, and helping incubate companies with tech-entrepreneurs. Prior to becoming an accidental venture capitalist, BG had a first career as a builder and engineering executive in Silicon Valley through various interesting gigs over two decades. He ran engineering at NerdWallet, helping scale the company to a market leader in consumer finance marketplaces and prior to that, as the founding Head of Data Engineering at LinkedIn, he and his team built and ran the data platforms that helped  enable LinkedIn's meteoric growth from 50MM to 550MM+ members. BG also ran engineering at Yahoo! RightMedia ads exchange, and learnt about “big data” while writing parts of the Oracle and Informix RDBMS kernels.  BG has a PhD in Computer Science from Yale and a holder of 22 US patents. | Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
    },
    talkDetails: [
      {
        title: "Data Federation with GraphQL",
        description: {
          lists: [
            "Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
          ],
          subLists: [
            "How do people access data?",
            "How does GraphQL help?",
            "What kind of systems are being used to get GraphQL to federate data within an org?",
            "What do you wish you’d known before you started your Data Federation journey?",
            "Let’s learn from the panel.",
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/data-federation-with-graphql/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/data-federation-with-graphql/watch/",
    talkTitleType: "Panel Discussion",
    time: "10:30am - 11:30am",
    speakersName: "Bhaskar Ghosh",
    speakersImg: bhaskarImg,
    linkedinLink: "https://www.linkedin.com/in/ghoshbhaskar/",
    about: {
      lists: [
        "Bhaskar Ghosh (BG)  is  Partner and CTO at Silicon Valley venture capital firm 8VC, where he focuses on investing in early-phase start-ups building B2B SaaS, enterprise infrastructure and  data-driven businesses, and helping incubate companies with tech-entrepreneurs. Prior to becoming an accidental venture capitalist, BG had a first career as a builder and engineering executive in Silicon Valley through various interesting gigs over two decades. He ran engineering at NerdWallet, helping scale the company to a market leader in consumer finance marketplaces and prior to that, as the founding Head of Data Engineering at LinkedIn, he and his team built and ran the data platforms that helped  enable LinkedIn's meteoric growth from 50MM to 550MM+ members. BG also ran engineering at Yahoo! RightMedia ads exchange, and learnt about “big data” while writing parts of the Oracle and Informix RDBMS kernels.  BG has a PhD in Computer Science from Yale and a holder of 22 US patents.",
      ],
    },
    speakersDesignation: (
      <span>
        Partner &amp; CTO <br />
        8VC
      </span>
    ),
  },
  {
    url: "/enterprisegraphql/2020/speakers/nagaraja-nayak/",
    metaTags: {
      title: "Nagaraja Nayak | Digital Transformation at Optum",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/nagaraja-nayak/",
      description:
        "Nagaraja is working in Optum Technology as Vice President in Enterprise Clinical Technology. His role is Engineering lead in Optum Clinical Manager – Enterprise Clinical Platform. He is responsible for Data Architecture; Data, Analytics including AI/ML and Site Reliability Engineering (SRE) of the Clinical Platform. He worked in Texas Instruments, Target and Bluestem Brands prior to Optum. He lives with wife and 2 boys. Besides software engineering, he loves to cook, travel and bike with his kids.",
    },
    talkDetails: [
      {
        title: "Digital Transformation at Optum",
        description: {
          lists: [
            "The Enterprise Clinical Team at Optum has implemented an elegant GraphQL infrastructure and are using GraphQL & Hasura in their modernization journey. In this panel with senior leadership at Optum, they will share the how and the why of their approach, the business benefits they’re observing from this shift, and finally we will hear their insights on best practices for architects in large enterprises who are looking to adapt GraphQL within their own organization.",
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/digital-transformation-at-optum/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/digital-transformation-at-optum/watch/",
    talkTitleType: "Talk Title",
    time: "11:45am - 12:30pm",
    speakersName: "Nagaraja Nayak",
    speakersImg: nagarajaImg,
    linkedinLink: "https://www.linkedin.com/in/nagaraja-nayak-14b2304/",
    about: {
      lists: [
        "Nagaraja is working in Optum Technology as Vice President in Enterprise Clinical Technology. His role is Engineering lead in Optum Clinical Manager – Enterprise Clinical Platform. He is responsible for Data Architecture; Data, Analytics including AI/ML and Site Reliability Engineering (SRE) of the Clinical Platform. He worked in Texas Instruments, Target and Bluestem Brands prior to Optum. He lives with wife and 2 boys. Besides software engineering, he loves to cook, travel and bike with his kids.",
      ],
    },
    speakersDesignation: (
      <span>
        VP Data Engineering <br />
        Optum
      </span>
    ),
  },
  {
    url: "/enterprisegraphql/2020/speakers/gurumurthy-sithuraj/",
    metaTags: {
      title: "Gurumurthy Sithuraj | Digital Transformation at Optum",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/speakers/gurumurthy-sithuraj/",
      description: "Gurumurthy Sithuraj is a Director of IT at UnitedHealth Group",
    },
    talkDetails: [
      {
        title: "Digital Transformation at Optum",
        description: {
          lists: [
            "The Enterprise Clinical Team at Optum has implemented an elegant GraphQL infrastructure and are using GraphQL & Hasura in their modernization journey. In this panel with senior leadership at Optum, they will share the how and the why of their approach, the business benefits they’re observing from this shift, and finally we will hear their insights on best practices for architects in large enterprises who are looking to adapt GraphQL within their own organization.",
          ],
        },
      },
    ],
    videoPageLink: "/enterprisegraphql/2020/talks/digital-transformation-at-optum/watch/",
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/digital-transformation-at-optum/watch/",
    talkTitleType: "Talk Title",
    time: "11:45am - 12:30pm",
    speakersName: "Gurumurthy Sithuraj",
    speakersImg: gurumurthyImg,
    linkedinLink: "https://www.linkedin.com/in/gurumurthysithuraj/",
    about: {
      lists: ["Gurumurthy Sithuraj is a Director of IT at UnitedHealth Group"],
    },
    speakersDesignation: (
      <span>
        Director of IT <br />
        UnitedHealth Group
      </span>
    ),
  },
];
const scheduleEventsDetails = [
  {
    url:
      "/enterprisegraphql/2020/talks/enabling-innovation-and-empowering-developers-graphqls-role-in-the-enterprise/",
    metaTags: {
      title: "Enabling Innovation & Empowering Developers - GraphQL’s role in the Enterprise",
      canonicalUrl:
        "https://hasura.io/enterprisegraphql/2020/talks/enabling-innovation-and-empowering-developers-graphqls-role-in-the-enterprise/",
      description:
        "Technology adoption in the enterprise can be a winding road. When new frameworks, new approaches, new design patterns, even new query languages are developed there is time between emergence and maturation.",
    },
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/enabling-innovation-and-empowering-developers-graphqls-role-in-the-enterprise/watch/",
    title: "Enabling Innovation & Empowering Developers - GraphQL’s role in the Enterprise",
    description: {
      lists: [
        "Technology adoption in the enterprise can be a winding road. When new frameworks, new approaches, new design patterns, even new query languages are developed there is time between emergence and maturation. Have you asked, or have you heard, the questions:",
      ],
      subLists: [
        "Is GraphQL only for side projects?",
        "Is anyone really using GraphQL at enterprise scale?",
        "Is GraphQL production ready?",
      ],
      listsTwo: [
        "Tanmai, Hasura CEO and founder, will keynote the Enterprise GraphQL conference addressing these questions, and more, while laying out the foundation for understanding how to unlock your data with GraphQL in your organisation (regardless of the size).",
      ],
    },
    videoLink: "https://player.vimeo.com/video/473214242",
    talkType: "Tanmai Gopal",
    time: "9:00am - 9:45am",
    talkTitleType: "Talk Title",
    nameDesignation: (
      <span>
        Tanmai Gopal
        <br />
        Hasura
      </span>
    ),
    speakersList: [
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/tanmai-gopal/",
        speakersName: "Tanmai Gopal",
        speakersImg: tanmaiImg,
        speakersDesignation: (
          <span>
            Co-Founder
            <br /> Hasura
          </span>
        ),
      },
    ],
  },
  {
    url: "/enterprisegraphql/2020/talks/the-new-data-fabric-2020-as-a-trigger-for-innovation/",
    metaTags: {
      title: "The New Data Fabric, 2020 as a trigger for innovation",
      canonicalUrl:
        "https://hasura.io/enterprisegraphql/2020/talks/the-new-data-fabric-2020-as-a-trigger-for-innovation/",
      description:
        "The industry is quickly moving to a model of higher level of services and abstraction, in all layers of the stack, from compute to storage to networking and application deployment and delivery. While we've seen a ton of innovation in data and data management, we're now seeing an acceleration in that space, with developer experience as a key driver for the new platforms and capabilities. Programming languages are becoming more data friendly, and data services are increasingly being defined by new APIs, notably GraphQL. The pendulum is swinging from 3 tier application models to 2 tier, with rich interactive front ends orchestrating from a palette of back end services - client/serverless is a thing. In this talk James will discuss how enterprises can build more powerful data driven apps using new technologies and methods, putting all of this change into context.",
    },
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/the-new-data-fabric-2020-as-a-trigger-for-innovation/watch/",
    title: "The New Data Fabric, 2020 as a trigger for innovation",
    description: {
      lists: [
        "The industry is quickly moving to a model of higher level of services and abstraction, in all layers of the stack, from compute to storage to networking and application deployment and delivery. While we've seen a ton of innovation in data and data management, we're now seeing an acceleration in that space, with developer experience as a key driver for the new platforms and capabilities. Programming languages are becoming more data friendly, and data services are increasingly being defined by new APIs, notably GraphQL. The pendulum is swinging from 3 tier application models to 2 tier, with rich interactive front ends orchestrating from a palette of back end services - client/serverless is a thing. In this talk James will discuss how enterprises can build more powerful data driven apps using new technologies and methods, putting all of this change into context.",
      ],
    },
    videoLink: "https://player.vimeo.com/video/473200832",
    talkType: "James Governor",
    talkTitleType: "Talk Title",
    time: "9:45am - 10:30am",
    nameDesignation: (
      <span>
        James Governor
        <br />
        Redmonk
      </span>
    ),
    speakersList: [
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/james-governor/",
        speakersName: "James Governor",
        speakersImg: jamesImg,
        speakersDesignation: (
          <span>
            Founder
            <br /> RedMonk
          </span>
        ),
      },
    ],
  },
  {
    url: "/enterprisegraphql/2020/talks/data-federation-with-graphql/",
    metaTags: {
      title: "Data Federation with GraphQL",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/talks/data-federation-with-graphql/",
      description:
        "Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
    },
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/data-federation-with-graphql/watch/",
    title: "Data Federation with GraphQL",
    description: {
      lists: [
        "Data is everywhere. And we all know that data access can be a bottleneck. This problem only becomes more difficult with microservices & many many apps within an org.",
      ],
      subLists: [
        "How do people access data?",
        "How does GraphQL help?",
        "What kind of systems are being used to get GraphQL to federate data within an org?",
        "What do you wish you’d known before you started your Data Federation journey?",
        "Let’s learn from the panel.",
      ],
    },
    videoLink: "https://player.vimeo.com/video/473096066",
    talkType: "Panel Discussion",
    time: "10:30am - 11:30am",
    talkTitleType: "Panel Discussion",
    nameDesignation: (
      <span>
        Diana Suvorova, Deep Ganguly, Tanmai Gopal, Bhaskar Ghosh & Allison Kunz
        <br />
        Uber, SAP, Hasura, 8VC
      </span>
    ),
    borderRemove: true,
    multipleSpeakers: "Speakers",
    speakersList: [
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/diana-suvorova/",
        speakersName: "Diana Suvorova",
        speakersImg: dianaImg,
        speakersDesignation: (
          <span>
            Senior Software Engineer <br />
            Uber
          </span>
        ),
      },
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/deep-ganguly/",
        speakersName: "Deep Ganguly",
        speakersImg: deepImg,
        speakersDesignation: (
          <span>
            Product Manager
            <br /> SAP Cloud Platform Integration Suite
          </span>
        ),
      },
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/tanmai-gopal/",
        speakersName: "Tanmai Gopal",
        speakersImg: tanmaiImg,
        speakersDesignation: (
          <span>
            Co-Founder
            <br /> Hasura
          </span>
        ),
      },
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/bhaskar-ghosh/",
        speakersName: "Bhaskar Ghosh",
        speakersImg: bhaskarImg,
        speakersDesignation: (
          <span>
            Partner &amp; CTO <br />
            8VC
          </span>
        ),
      },
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/allison-kunz/",
        speakersName: "Allison Kunz",
        speakersImg: alisonImg,
        speakersDesignation: (
          <span>
            Solutions Engineer <br />
            Hasura
          </span>
        ),
      },
    ],
  },
  {
    type: "break",
    breakTime: "15 mins Break",
  },
  {
    url: "/enterprisegraphql/2020/talks/digital-transformation-at-optum/",
    metaTags: {
      title: "Digital Transformation at Optum",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/talks/digital-transformation-at-optum/",
      description:
        "The Enterprise Clinical Team at Optum has implemented an elegant GraphQL infrastructure and are using GraphQL & Hasura in their modernization journey. In this panel with senior leadership at Optum, they will share the how and the why of their approach, the business benefits they’re observing from this shift, and finally we will hear their insights on best practices for architects in large enterprises who are looking to adapt GraphQL within their own organization.",
    },
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/digital-transformation-at-optum/watch/",
    title: "Digital Transformation at Optum",
    description: {
      lists: [
        "The Enterprise Clinical Team at Optum has implemented an elegant GraphQL infrastructure and are using GraphQL & Hasura in their modernization journey. In this panel with senior leadership at Optum, they will share the how and the why of their approach, the business benefits they’re observing from this shift, and finally we will hear their insights on best practices for architects in large enterprises who are looking to adapt GraphQL within their own organization.",
      ],
    },
    videoLink: "https://player.vimeo.com/video/473176079",
    time: "11:45am - 12:30pm",
    talkType: "Panel Discussion",
    nameDesignation: (
      <span>
        Latha Budideti, Nagaraja Nayak & Gurumurthy Sithuraj
        <br />
        Optum
      </span>
    ),
    multipleSpeakers: "Speakers",
    talkTitleType: "Panel Discussion",
    speakersList: [
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/latha-budideti/",
        speakersName: "Latha Budideti",
        speakersImg: lathaImg,
        speakersDesignation: (
          <span>
            VP Software Engineering
            <br />
            Optum
          </span>
        ),
      },
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/nagaraja-nayak/",
        speakersName: "Nagaraja Nayak",
        speakersImg: nagarajaImg,
        speakersDesignation: (
          <span>
            VP Data Engineering <br />
            Optum
          </span>
        ),
      },
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/gurumurthy-sithuraj/",
        speakersName: "Gurumurthy Sithuraj",
        speakersImg: gurumurthyImg,
        speakersDesignation: (
          <span>
            Director of IT <br />
            UnitedHealth Group
          </span>
        ),
      },
    ],
  },
  {
    url: "/enterprisegraphql/2020/talks/building-airbnbs-Data-graph/",
    metaTags: {
      title: "Building Airbnb’s Data Graph",
      canonicalUrl: "https://hasura.io/enterprisegraphql/2020/talks/building-airbnbs-Data-graph/",
      description:
        'As Airbnb transitioned from its Ruby on Rails monolith to a service-oriented architecture, many parts of our application have become better managed, better organized, and higher quality. Our APIs and our data, however, became fragmented and difficult to use and understand. Over the past year, Airbnb has been building a platform to unify our data graph and make data access and product logic more understandable and reusable, allowing us to harmonize our many microservices through what we call a "data-oriented service mesh". I’ll talk about our motivations, the developer experience of using this unified graph, and where we’re looking to take the platform in the future.',
    },
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/building-airbnbs-Data-graph/watch/",
    title: "Building Airbnb’s Data Graph",
    description: {
      lists: [
        'As Airbnb transitioned from its Ruby on Rails monolith to a service-oriented architecture, many parts of our application have become better managed, better organized, and higher quality. Our APIs and our data, however, became fragmented and difficult to use and understand. Over the past year, Airbnb has been building a platform to unify our data graph and make data access and product logic more understandable and reusable, allowing us to harmonize our many microservices through what we call a "data-oriented service mesh". I’ll talk about our motivations, the developer experience of using this unified graph, and where we’re looking to take the platform in the future.',
      ],
    },
    videoLink: "https://player.vimeo.com/video/473436922",
    time: "12:30pm - 1:15pm",
    talkType: "Adam Miskiewicz",
    talkTitleType: "Talk Title",
    nameDesignation: (
      <span>
        Adam Miskiewicz
        <br />
        Airbnb
      </span>
    ),
    speakersList: [
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/adam-miskiewicz/",
        speakersName: "Adam Miskiewicz",
        speakersImg: adamImg,
        speakersDesignation: (
          <span>
            Staff Engineer <br />
            Airbnb
          </span>
        ),
      },
    ],
  },
  {
    url: "/enterprisegraphql/2020/talks/moving-fast-and-not-breaking-things/",
    metaTags: {
      title: "Moving Fast & Not Breaking Things",
      canonicalUrl:
        "https://hasura.io/enterprisegraphql/2020/talks/moving-fast-and-not-breaking-things/",
      description:
        "This panel will focus on introducing new tech (GraphQL) incrementally without breaking existing systems. The topics on the panel will focus on the adoption motions of GraphQL, developer productivity, benefits that you see as an org, what problems GraphQL solutions are solving, best practices for org-wide incremental adoption, etc. From success stories to challenges (that can be shared publicly), expect a frank conversation of the good, the bad, and the amazing.",
    },
    videoPageCanonical:
      "https://hasura.io/enterprisegraphql/2020/talks/moving-fast-and-not-breaking-things/watch/",
    title: "Moving Fast & Not Breaking Things",
    description: {
      lists: [
        "This panel will focus on introducing new tech (GraphQL) incrementally without breaking existing systems. The topics on the panel will focus on the adoption motions of GraphQL, developer productivity, benefits that you see as an org, what problems GraphQL solutions are solving, best practices for org-wide incremental adoption, etc. From success stories to challenges (that can be shared publicly), expect a frank conversation of the good, the bad, and the amazing.",
      ],
    },
    videoLink: "https://player.vimeo.com/video/473143023",
    time: "1:15pm - 2:00pm",
    talkType: "Panel Discussion",
    nameDesignation: (
      <span>
        Ashwin Goyal, Evan Huus and Tanmai Gopal
        <br />
        Swiggy, Shopify, Hasura
      </span>
    ),
    multipleSpeakers: "Speakers",
    talkTitleType: "Panel Discussion",
    speakersList: [
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/ashwin-goyal/",
        speakersName: "Ashwin Goyal",
        speakersImg: ashwinGoyalImg,
        speakersDesignation: (
          <span>
            New Initiatives <br />
            Swiggy
          </span>
        ),
      },
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/evan-huus/",
        speakersName: "Evan Huus",
        speakersImg: evanImg,
        speakersDesignation: (
          <span>
            Developer Lead
            <br /> Shopify
          </span>
        ),
      },
      {
        speakersUrl: "/enterprisegraphql/2020/speakers/tanmai-gopal/",
        speakersName: "Tanmai Gopal",
        speakersImg: tanmaiImg,
        speakersDesignation: (
          <span>
            Co-Founder
            <br /> Hasura
          </span>
        ),
      },
    ],
  },
  {
    title: "Closing Notes",
    time: "2:00pm - 2:15pm",
    borderRemove: true,
  },
];
const scheduleTopicDetails = [
  {
    title: "Authorisation",
    time: "10:30am - 11:00am",
    nameDesignation: "All things GraphQL + Auth",
  },
  {
    title: "Security",
    time: "11:00am - 11:30am",
    nameDesignation: "How to build secure GraphQL APIs",
  },
  {
    title: "Data Federation",
    time: "11:30am - 12:00pm",
    nameDesignation:
      "Go in-depth into how Data Federation and GraphQL can transform data access for your enteprise teams",
  },
  {
    title: "Scaling Your Backend",
    time: "12:00pm to 12:30pm",
    nameDesignation: "Learn how to make your GraphQL scaleable",
  },
];
const confVideos = [
  {
    title: "Enabling Innovation & Empowering Developers - GraphQL’s role in the Enterprise",
    nameOrg: (
      <span>
        Tanmai Gopal
        <br />
        Hasura
      </span>
    ),
    videoLink: "https://player.vimeo.com/video/473214242",
  },
  {
    title: "The New Data Fabric, 2020 as a trigger for innovation",
    nameOrg: (
      <span>
        James Governor
        <br />
        Redmonk
      </span>
    ),
    videoLink: "https://player.vimeo.com/video/473200832",
  },
  {
    title: "Data Federation with GraphQL",
    nameOrg: (
      <span>
        Diana Suvorova, Deep Ganguly, Tanmai Gopal, Bhaskar Ghosh, Allison Kunz
        <br />
        Uber, SAP, Hasura, 8VC
      </span>
    ),
    videoLink: "https://player.vimeo.com/video/473096066",
  },
  {
    title: "Digital Transformation at Optum",
    nameOrg: (
      <span>
        Latha Budideti, Nagaraja Nayak, Gurumurthy Sithuraj
        <br />
        Optum
      </span>
    ),
    videoLink: "https://player.vimeo.com/video/473176079",
  },
  {
    title: "Building Airbnb’s Data Graph",
    nameOrg: (
      <span>
        Adam Miskiewicz
        <br />
        Airbnb
      </span>
    ),
    videoLink: "https://player.vimeo.com/video/473436922",
  },
  {
    title: "Moving Fast & Not Breaking Things",
    nameOrg: (
      <span>
        Ashwin Goyal, Evan Huus and Tanmai Gopal
        <br />
        Swiggy, Shopify, Hasura
      </span>
    ),
    videoLink: "https://player.vimeo.com/video/473143023",
  },
];
const workshopVideo = [
  {
    title: "Hasura Workshop: Building an Enterprise-Grade Data Access Layer with GraphQL & Hasura",
    nameOrg: (
      <span>
        Adron Hall
        <br />
        Hasura
      </span>
    ),
    videoLink: "https://player.vimeo.com/video/473458193",
  },
];
export { speakersDetails, scheduleEventsDetails, scheduleTopicDetails, confVideos, workshopVideo };
